module.exports = __webpack_public_path__ + "static/img/1_3_4.88d82bda.jpg";